<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
  >
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M6,0 C5.56389474,0 5.21052632,0.353526316 5.21052632,0.789473684 L5.21052632,5.21052632 L0.789473684,5.21052632 C0.353526316,5.21052632 0,5.56405263 0,6 C0,6.43610526 0.353526316,6.78947368 0.789473684,6.78947368 L5.21052632,6.78947368 L5.21052632,11.2105263 C5.21052632,11.6466316 5.56389474,12 6,12 C6.43610526,12 6.78947368,11.6466316 6.78947368,11.2105263 L6.78947368,6.78947368 L11.2105263,6.78947368 C11.6466316,6.78947368 12,6.43610526 12,6 C12,5.56405263 11.6466316,5.21052632 11.2105263,5.21052632 L6.78947368,5.21052632 L6.78947368,0.789473684 C6.78947368,0.353526316 6.43610526,0 6,0"
    />
  </svg>
</template>
